import { CloudStore } from "@omni/types/api/store/cloud/store.model";
import { useSelector } from "react-redux";

import { Messages } from "@/components/General/Messages/messages.container";
import { useThunkDispatch } from "@/redux/dispatcher";
import { update as updateProductDetail } from "@/redux/modules/value/productDetail/productDetail.module";
import { getProductDetail } from "@/redux/modules/value/productDetail/productDetail.selectors";
import {
    StorePersistenceStrategy,
    StoreService
} from "@/services/store.service";

import { StorePickerComponent } from "./storePicker.component";
import { STORE_PICKER_MESSAGE_ID } from "./storePicker.config";
import { StorePickerContextProvider } from "./storePicker.context";
import { StorePickerConfig } from "./types/storePickerConfig.type";
import { StorePickerType } from "./types/storePickerType.enum";

type StorePickerProps = { disabled?: boolean } & StorePickerConfig;

export const StorePicker = ({
    disabled = false,
    ...config
}: StorePickerProps) => {
    const dispatch = useThunkDispatch();
    const productDetail = useSelector(getProductDetail);

    const handleOnSubmit = (store: CloudStore) => {
        dispatch(updateProductDetail({ shop: store }));

        StoreService.setStoreCode(
            config.type === StorePickerType.SELECT_DRIVE_IN
                ? StorePersistenceStrategy.SessionDriveIn
                : StorePersistenceStrategy.Session,
            store.code
        );

        if (
            config.type === StorePickerType.SELECT ||
            config.type === StorePickerType.SELECT_DRIVE_IN
        ) {
            return config.onSubmit(store, config.onClose);
        }

        config.onClose?.();
    };

    return (
        <>
            <Messages messageid={STORE_PICKER_MESSAGE_ID} />
            <StorePickerContextProvider
                disabled={disabled}
                config={config}
                sku={
                    config.type === StorePickerType.CUSTOM
                        ? (config.sku ?? undefined)
                        : productDetail.sku
                }
                onSubmit={handleOnSubmit}
            >
                <StorePickerComponent />
            </StorePickerContextProvider>
        </>
    );
};
